module.exports = __webpack_public_path__ + "static/img/bord_de_mer.06ccaa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bord_de_mer.jpg
// module id = 23
// module chunks = 0